import React from 'react';

function UserListItem(props) {
    return(
            <li>
                <h1>First Name: {props.fname}</h1>
                <h1>Last Name: {props.lname}</h1>
                <h2>Profile Image: 
                    <img 
                        src={props.imageUrl}
                        alt={props.fname} />
                </h2>
                <h2>City: {props.city}</h2>
                <h2>State: {props.state}</h2>
                <h2>Email: {props.email}</h2>
                <h2>Gender Icon: <img 
                        style={{ width: 50 }}
                        src={props.genderImage}
                        alt={props.gender} /></h2>
                {props.natImage && (
                    <h2>Nationality: {props.nat} <img 
                        style={{ width: 30 }}
                        src={props.natImage}
                        alt={props.nat} /></h2>
                )}  
                <button 
                    type="button" 
                    value={props.value} 
                    onClick={() => props.onClick(props.value)}>
                        Delete
                </button>
            </li>
        );
}

export default UserListItem;